import http from './http';
export default {
  //加盟
  Submission(data) {
    return http.post(`partner/saveform`, data);
  },
  //厂家加盟
  Manufacturers(data) {
    return http.post(`/vender/savevender`, data)
  },
  Immediate(data) {
    return http.post(`/client/saveclient`, data)
  },
  gemock() {
    return http.post(`/data/index`)
  },
  //列表数据
  getproduct() {
    return http.get(`/mat/list`)
  },
  //筛选
  postfilterselect(data) {
    return http.post(`/mat/materialsselect3`, data)
  },
  //搜索
  search(data) {
    return http.post(`/mat/matname`, data)
  },
  //套餐筛选
  postGrade(data) {
    return http.get(`/setmeal/selectgrade`, { params: data })
  },
  //套餐详情
  pkdetails(data) {
    return http.get(`/setmeal/setdetail/`, { params: data })
  },
  //设计师
  postshejis(data) {
    return http.post(`/designer/list`, data)
  },
  //富文本
  gethtmllist(data) {
    return http.get(`/setmeal/sethd`, { params: data })
  },
  //精选效果图列表
  sketch(data) {
    return http.post(`/designer/cltlist`, data)
  },
  //案例详情
  ctdetails(data) {
    return http.post(`/designer/listpic`, data)
  },
  //全景图列表
  cltpanolist(data) {
    return http.post(`/designer/cltpanolist`, data)
  },
  //全景图二级列表
  browse(data) {
    return http.post(`/designer/listpano`, data)
  },
  //风格接口
  style() {
    return http.get(`/zcase/style`)
  },
  //装修案例筛选
  Packagescreening(data) {
    return http.post(`/zcase/list`, data)
  },
  decorations(data) {
    return http.get(`/zcase/info/${data.docid}`)
  },
  //报名人数
  applicants(data) {
    return http.post(`/client/querynum`, data)
  },
  // //贷款预约
  // LoanReservation(data){
  //   return http.post(`/client/saveclient`,data)
  // },
  //产品详情
  getDetails(data) {
    return http.get(`/setmatinfo/selectMatInfoByMatId/${data}`)
  },
  //套餐详情
  getpack(data) {
    return http.get(`/setmeal/setdetail?setid=${data}`)
  },
  //设计师信息
  designerinfo(data) {
    return http.post(`designer/selectDesignerInfo`, data)
  },
  //设计师案例
  designercase(data) {
    return http.post('designer/selectCustomerCases', data)
  },
  //套餐页产品详情
  packproduct(data) {
    return http.post('setmatinfo/selectNowAndOtherMat', data)
  },
  //加盟商授权信息查询
  joinsearch(data) {
    return http.post('partner/selectJoinAuthorizeInfo', data)
  },
  //预约
  appointment(data) {
    return http.post(`/client/saveclient`, data)
  },
  //在线工地列表查询
  onlinesite(data) {
    return http.post(`project/selectOnlineSiteListPage`, data)
  },
  //在线工地详情
  onlinesiteDetails(data) {
    return http.post(`project/selectOnlineSiteDetail`, data)
  },
  //装修宝典文章分页列表
  article(data) {
    return http.post(`article/articlelistpage`, data)
  },
  //装修宝典文章详情
  articledetail(data) {
    return http.post(`article/selectArticleDetailById`, data)
  },
  //添加浏览人数
  articleview(data) {
    return http.post(`article/addReadNumById`, data)
  },
  //产品富文本
  gethtml(data) {
    return http.get(`mmmemo/htmlinfo/${data}`)
  },
};